/* eslint-disable import/order */
/* eslint-disable no-nested-ternary */
import { Box } from '@mui/material'
import { ReactElement } from 'react'
import { useAppSelector } from 'src/store/hooks'
import { selectCurrentStep, selectStreamItems } from '../classroom.slice'
import TitleScreenStep from './title-screen-step'
import TextContentStep from './text-content-step'
import QuizStep from './quiz-step'
import VideoStep from './video-step'

export default (): ReactElement => {
  let streamItems = useAppSelector(selectStreamItems)
  let currentStep = useAppSelector(selectCurrentStep)

  return (
    <>
      <Box sx={{ p: 2 }}>
        {streamItems?.length &&
        streamItems?.[currentStep]?.type === 'title_screen' ? (
          <TitleScreenStep></TitleScreenStep>
        ) : streamItems?.[currentStep]?.type === 'video' ? (
          <VideoStep />
        ) : streamItems?.[currentStep]?.type === 'text_content' ? (
          <TextContentStep></TextContentStep>
        ) : streamItems?.[currentStep]?.type === 'quiz' ? (
          <QuizStep></QuizStep>
        ) : (
          <></>
        )}
      </Box>
    </>
  )
}
